<ng-container [formGroup]="form">
    <fieldset 
        class="_mb-4"
        [ngClass]="modifierClassname">
        <label 
            [for]="fieldId"
            class="_inline-block _relative _ml-2 _mb-1 _text-md"
            [class._required-field]="required"
            [ngClass]="darkTheme ? '_text-white' : '_text-black'">
            {{label}}
        </label>
        <textarea 
            [id]="fieldId"
            [formControlName]="fieldId"
            [class._input-invalid]="control.invalid && control.touched"
            [ngClass]="{ '_input-dark' : darkTheme, '_min-w-60' : useMinWidth }"
            class="_input-squared _input-slim _p-2 _min-w-60 _w-full"
            type="text" 
            [value]="value" 
            [ngStyle]="{ minHeight : minHeight }"
            [placeholder]="placeholderText">
        </textarea>
        <div *ngIf="control.invalid && control.touched" class="_text-error-red-light _text-sm _mt-1 _ml-2">
            <div *ngIf="control.errors?.required">Field is required</div>
        </div>
    </fieldset>
</ng-container>
